import React from "react";
import "./style.scss";

import Buttom from "../../components/Buttom";
import Title from "../../components/Title";
import LayoutSteps from "../Shared/LayoutSteps";

import { ContextDefault } from "./../../context/Provider";

const EducacaoFisica = () => {
  const context = React.useContext(ContextDefault);

  React.useEffect(() => {
    context.actions.setProgressBarVisiblity(false);
  }, [context.actions]);

  return (
    <LayoutSteps className="wrapper-fisica" renderButtom={props => <Buttom data-class="btn-donation--default" {...props} />}>
      <div className="container">
        <Title className="title">Pessoa Física</Title>
        <p>
          Pessoas físicas que queiram apoiar nossos projetos incentivados podem deduzir o valor da doação em até 6% do imposto de renda devido.  Para saber mais como apoiar, envie um e-mail para &nbsp;
          <a href="maito:apoie@institutopeninsula.org.br">apoie@institutopeninsula.org.br</a>
        </p>
      </div>
    </LayoutSteps>
  );
};

export default EducacaoFisica;
